import { render } from "./Unit2-5.vue?vue&type=template&id=cfed179a&scoped=true"
import script from "./Unit2-5.vue?vue&type=script&lang=js"
export * from "./Unit2-5.vue?vue&type=script&lang=js"

import "./Unit2-5.vue?vue&type=style&index=0&id=cfed179a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfed179a"]])

export default __exports__